import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import SuspenseSpinner from 'Utils/SuspenseSpinner';
import {
  settingsSidebarCommon, settingsSidebarUsers,
  settingsSidebarSoftware, settingsSidebarEvents,
} from './Sidebar';

import { SettingsTopBar } from './Settings.Topbar';
import { SettingsTopbarPage } from './Settings.Topbar.Page';
import SettingsCommonRouter from './Settings.Common/Router.Common';
import SettingsUsersRouter from './Settings.Users/Router.Users';
import SettingsSoftwareRouter from './Settings.Software/Router.Software';
import SettingsEventsRouter from './Settings.Events/Router.Events';

export default function SettingsRouter() {
  return (
    <Suspense fallback={<SuspenseSpinner />}>
      <Routes>
        <Route path="/" element={<SettingsTopBar />}>
          <Route index element={<Navigate to="common" replace />} />
          <Route path="common/*" element={<SettingsTopbarPage sidebarGroups={settingsSidebarCommon} content={<SettingsCommonRouter />} />} />
          <Route path="users/*" element={<SettingsTopbarPage sidebarGroups={settingsSidebarUsers} content={<SettingsUsersRouter />} />} />
          <Route path="software/*" element={<SettingsTopbarPage sidebarGroups={settingsSidebarSoftware} content={<SettingsSoftwareRouter />} />} />
          <Route path="journals/*" element={<SettingsTopbarPage sidebarGroups={settingsSidebarEvents} content={<SettingsEventsRouter />} />} />

          <Route path="*" element={<Navigate to="common" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
